import React, { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import RequestModal from '../Modals/InvoicedRequestModal';
import { toast } from 'react-toastify';

import { Card, Container, Row, Col, Button, Form} from 'react-bootstrap';

import { timestampToHTMLDateInput/*, HTMLDateInputToTimestamp, currentTimeStamp*/} from '../HelperFunctions/dateConverters';

import { db } from '../firebase-config';
import { collection, query, getDocs, where, orderBy, limit, doc, getDoc} from 'firebase/firestore';

import StatusSpinner from '../Components/StatusSpinner';

export default function EmployeeInvoiced() {
   const { setShowSpinner, showSpinner } = useAuth();
    const [listOfWorkOrders, setListOfWorkOrders] = useState([]);
    const [chosenRequest, setChosenRequest] = useState({});
    const [currentWorkOrderHours, setCurrentWorkOrderHours] = useState([]);
    const [currentHeading, setCurrentHeading] = useState('Last 10 Invoiced Work Orders');
    const [modalShow, setModalShow] = useState(false);
    const [defaultTruckCharge, setDefaultTruckCharge] = useState("");
    const [defaultDailyRates, setDefaultDailyRates] = useState({Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"});

    // const [where, setWhere] = useState("complete_timestamp");
    // const [whereOptions, setWhereOptions] = useState([]);
    // const [orderBy, setOrderBy] = useState("");
    const [workOrderSearch, setWorkOrderSearch] = useState("");
    const [limitSearch, setLimitSearch] = useState(10);

    const [currentClientInfo, setCurrentClientInfo] = useState({})

    useEffect(()=>{
        setShowSpinner(true);
        const q = query(collection(db, "invoiced_work_orders"), orderBy("complete_timestamp", "desc"), limit(10));
        //const q = query(collection(db, "invoiced_work_orders"));
        getDocs(q).then((querySnapshot)=>{
            setShowSpinner(false);
            let tempListOfWorkOrders = [];
            querySnapshot.forEach((order)=>{
                tempListOfWorkOrders = [...tempListOfWorkOrders, {data: order.data(), id: order.id}];
            });
            tempListOfWorkOrders.sort((a,b) => {
                if(a.data.work_order.order_number > b.data.work_order.order_number) return 1;
                if(a.data.work_order.order_number < b.data.work_order.order_number) return -1;
                return 0;
            });
            setListOfWorkOrders(tempListOfWorkOrders);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Failed to load data: ${error.message}`);
        });
    }, [setShowSpinner]);

    const loadHours = (requestID)=>{
        return new Promise(async (resolve, reject)=>{
          setShowSpinner(true);
          try{
            let hoursData = [];
            const q = query(collection(db, "hours"), where("requestID", "==", requestID));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc)=>{
              hoursData = [...hoursData, doc.data()];
            });
            resolve(hoursData);
          }catch(error){
            reject(error.message);
          }
          setShowSpinner(false);
        });
    };
    const loadRates = ()=>{
        return new Promise(async (resolve, reject)=>{
            setShowSpinner(true);
            getDocs(collection(db, "rates")).then((snapShot)=>{
                let tempTruckCharge = "0";
                let tempDailyRates = {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"};
                snapShot.forEach((doc)=>{
                    if(doc.id === 'truck'){
                        tempTruckCharge = doc.data().rate;
                    }
                    if(doc.id === 'daily_tech_rates'){
                        tempDailyRates = doc.data();
                    }
                });
                return {truckCharge: tempTruckCharge, dailyRates: tempDailyRates};
            }).then((info)=>{
                setShowSpinner(false);
                setDefaultTruckCharge(info.truckCharge);
                setDefaultDailyRates(info.dailyRates);
                resolve('complete');
            }).catch((error)=>{
                setShowSpinner(false);
                toast.error(`Error getting rates list: ${error.message}`);
                reject(error.message);
            });
        });
    };

    const newSearch = ()=>{
        if(limitSearch !== "" && limitSearch > 0){
            if(workOrderSearch === ""){
                setShowSpinner(true);
                const q = query(collection(db, "invoiced_work_orders"), orderBy("complete_timestamp", "desc"), limit(limitSearch));
                getDocs(q).then((querySnapshot)=>{
                    setShowSpinner(false);
                    let tempListOfWorkOrders = [];
                    querySnapshot.forEach((order)=>{
                        tempListOfWorkOrders = [...tempListOfWorkOrders, {data: order.data(), id: order.id}];
                    });
                    console.log(tempListOfWorkOrders)
                    setListOfWorkOrders(tempListOfWorkOrders);
                }).catch((error)=>{
                    setShowSpinner(false);
                    toast.error(`Failed to load data: ${error.message}`);
                });
                setCurrentHeading(`Last ${limitSearch} Invoiced Work Orders`);
            }else{
                setShowSpinner(true);
                const q = query(collection(db, "invoiced_work_orders"), where("work_order.order_number", "==", workOrderSearch), limit(limitSearch));
                getDocs(q).then((querySnapshot)=>{
                    setShowSpinner(false);
                    let tempListOfWorkOrders = [];
                    querySnapshot.forEach((order)=>{
                        tempListOfWorkOrders = [...tempListOfWorkOrders, {data: order.data(), id: order.id}];
                    });
                    console.log(tempListOfWorkOrders)
                    setListOfWorkOrders(tempListOfWorkOrders);
                }).catch((error)=>{
                    setShowSpinner(false);
                    toast.error(`Failed to load data: ${error.message}`);
                });
                setCurrentHeading(`Order Number ${workOrderSearch}`);
            }
        }else{
            toast.warn('Limit cannot be blank and must be greater than 0');
        }
    };

    const loadClientInfo = (client_id, client_location_id)=>{
        // load customer profile and location profile information once for use, only update if props changes
        // props?.request?.data?.client_id
        // props?.request?.data?.client_location_id
        return new Promise(async (resolve, reject)=>{
          if(client_id !== undefined && client_id !== "" && client_id !== null){
            setShowSpinner(true);
            try{
              const docRef = doc(db, "client_information", client_id);
              const docSnap = await getDoc(docRef)
              setShowSpinner(false);
              if(docSnap.exists()){
                let tempClientInfo = {...docSnap.data()}
                delete tempClientInfo.Locations;
                if(client_location_id !== undefined && client_location_id !== "" && client_location_id !== null){
                  const locInfo = docSnap.data().Locations.filter(elem => elem.id === client_location_id);
                  if(locInfo.length > 0){
                    resolve({client_info: tempClientInfo, location_info: locInfo});
                  }else{
                    toast.info('Location no longer exists');
                    resolve({client_info: tempClientInfo, location_info: []})
                  }
                } else{
                  toast.info('No linked location');
                  resolve({client_info: tempClientInfo, location_info: []})
                }
                
              }else{
                toast.info(`Client no longer exists`);
                resolve({client_info: {}, location_info: []});
              }
            }catch(error){
              setShowSpinner(false);
              toast.error(`Failed to load client data: ${error.message}`);
              resolve({client_info: {}, location_info: []});
            }
          }else{
            toast.info('No linked Client Profile');
            resolve({client_info: {}, location_info: []});
          }
        });
        // will need to know if override is given as to not reoverride when modal loads again
        // maybe remove client database link or location database link
      };

    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        INVOICED WORK ORDERS
                    </Row>
                </Container>
            </Container>
            
            <Container fluid className="mt-4" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Row className="justify-content-center" style={{width:"100%"}}>
                    <Col lg="1">WO#:</Col>
                    <Col lg="3"><Form.Control type="text" value={workOrderSearch} onChange={(e)=>setWorkOrderSearch(e.target.value)} /></Col>
                    <Col lg="1">Limit:</Col>
                    <Col lg="3"><Form.Control type="number" min="1" value={limitSearch}  onChange={(e)=>{
                            if(e.target.value !== ""){
                                setLimitSearch(parseInt(e.target.value))
                            }else{
                                setLimitSearch("")
                            }
                        }} />
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{width:"100%"}}>
                    <Col lg="1">
                        <Button
                            className="btn-dark"
                            style={{backgroundColor:"#2596be", margin:5}}
                            onClick={()=>{
                                newSearch();
                            }}
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </Container>
            
            <Container fluid className="mt-4" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Row>
                    <Col lg="12">
                        <Card style={{border:"1px solid black"}}>
                            <Card.Header style={{textAlign:"center"}}>{currentHeading}</Card.Header>
                            <Card.Body style={{textAlign:"left"}}>
                            {
                                listOfWorkOrders.map((workorder, index)=>{
                                    return(
                                        <div
                                            key={index}
                                            style={{cursor:"pointer", borderBottom:"1px solid lightgrey", paddingTop:20}}
                                            onClick={async ()=>{
                                                try{
                                                    let hoursData = await loadHours(workorder.id);
                                                    await loadRates(); 
                                                    const clientInfo = await loadClientInfo(workorder.data?.client_id, workorder.data?.client_location_id);
                                                    console.log(hoursData);
                                                    console.log(clientInfo);
                                                    setCurrentClientInfo(clientInfo);
                                                    setCurrentWorkOrderHours(hoursData);
                                                    setChosenRequest(workorder);
                                                    setModalShow(true);
                                                  }catch(error){
                                                    toast.error(`Failed to load hours: ${error}`);
                                                  }
                                            }}
                                        >
                                            {timestampToHTMLDateInput(workorder.data.complete_timestamp)} - {workorder.data.type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}
                                        </div>
                                    )
                                })
                            }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            
            {
                showSpinner &&
                <StatusSpinner />
            }
            {
                <RequestModal
                    show={modalShow}
                    onHide={(cancelBit, updateOrderButtonStatus)=> {
                        if(cancelBit === 'show cancel' && updateOrderButtonStatus === 'save'){
                            toast.warn(`Canceled: No changes were made to the work order.`);
                        }
                        setModalShow(false);
                    }}
                    request={chosenRequest}
                    currentworkorderhours={currentWorkOrderHours}
                    currentclientinfo={currentClientInfo}
                    defaultdailyrates={defaultDailyRates}
                    defaulttruckcharge={defaultTruckCharge}
                />
            }
        </>
    )
}